// @ts-nocheck
import React, { useContext, useEffect, useState } from 'react';
import RegisterLayout from './RegisterLayout';
import moment from 'moment';
import { MyContext } from '../../../context';
import { showToast } from '../../../utils';
import DatePickerV2 from '../../../global/ui/DatePickerV2';

interface StepAvailabilityProps {
    onNext: (data: any) => void;
    onPrevious: () => void;
}


const getAvailabilityStatus = (availability_date: any) => {
    // null or empty
    if (!availability_date) {
        return "Available";
    }

    const today = moment().startOf('day');
    const availabilityDate = moment(availability_date).startOf('day');

    // Past or today
    if (availabilityDate.isSameOrBefore(today)) {
        return "Available";
    }

    const diffInDays = availabilityDate.diff(today, 'days');

    // Within one week
    if (diffInDays <= 7) {
        return "Available Soon";
    }

    // More than one week
    return "Not Available";
}

const daysAvailabilityData = [
    { level: 'Available' },
    { level: 'Available Soon' },
    { level: 'Not Available' },
];

const StepAvailability = ({ onNext, onPrevious }: StepAvailabilityProps) => {

    const { userData } = useContext(MyContext)

    const availabilityDate = userData?.crew_member_profile?.availability_date || '';

    const [selectedValue, setSelectedValue] = useState('Available');
    const [selectedDate, setSelectedDate] = useState<moment.Moment | null>(null);

    const today = moment().startOf('day');
    const minDateForAvailableSoon = today.clone();
    const maxDateForAvailableSoon = today.clone().add(7, 'days');
    const minDateForNotAvailable = today.clone().add(8, 'days');

    const disabledDate = (current: moment.Moment) => {
        if (selectedValue === 'Available Soon') {
            return current.isBefore(minDateForAvailableSoon, 'day') || current.isAfter(maxDateForAvailableSoon, 'day');
        }
        if (selectedValue === 'Not Available') {
            return current.isBefore(minDateForNotAvailable, 'day');
        }
        return false;
    };

    const handleNext = () => {
        if (!selectedValue) {
            showToast('Please select days availability.', 'error');
            return;
        }
        if ((selectedValue === 'Not Available' || selectedValue === 'Available Soon') && !selectedDate) {
            showToast('Please select date.', 'error');
            return;
        }

        if (selectedValue === 'Available') {
            onNext({})
        } else {
            const payload = {
                availability_date: selectedDate!.format('YYYY-MM-DD'),
            };
            onNext(payload)
        }




    };

    useEffect(() => {
        if (availabilityDate) {
            setSelectedValue(getAvailabilityStatus(availabilityDate));
            setSelectedDate(moment(availabilityDate, 'YYYY-MM-DD'));
        }
    }, [availabilityDate]);

    return (
        <RegisterLayout showLogout hideHeader>
            <div className="register-step">
                <div className="register-step__heading-block">
                    <h1 className="register-step__title">
                        When are you available
                    </h1>
                    <p className="register-step__description">
                        Share your preferred working hours and availability throughout the week. We use this information to find roles and shift patterns that work for both you and their business needs.
                    </p>
                </div>

                <div className="add-days-available">
                    <div className="availability-tabs">
                        {daysAvailabilityData?.map((item) => (
                            <button
                                key={item.level}
                                className={`availability-tab ${selectedValue === item.level ? 'active' : ''}`}
                                onClick={() => {
                                    setSelectedValue(item.level);
                                    setSelectedDate(null);
                                }}
                            >
                                {item?.level}
                            </button>
                        ))}
                    </div>

                    {(selectedValue === 'Not Available' || selectedValue === 'Available Soon') && (
                        <div className="date-section">
                            <div className="date-section__heading">
                                <h3 className="date-section__title">What is your end date?</h3>
                            </div>
                            <div style={{ zIndex: '12' }} >
                                <DatePickerV2
                                    date={selectedDate}
                                    onDateChange={setSelectedDate}
                                    label="Select Date"
                                    displayFormat="DD-MM-YYYY"
                                    openDirection='down'
                                    placeholder='Select Date'
                                    style={{ width: 'auto', marginBottom: '1.5rem' }}
                                    className="black-input"
                                />
                            </div>
                        </div>
                    )}
                </div>

                <div className="register-step__footer">
                    <button
                        className="btn-next btn-next--yellow"
                        type="button"
                        style={{ marginRight: 15 }}
                        onClick={onPrevious}
                    >
                        Previous
                    </button>
                    <button
                        className="btn-next btn-next--yellow"
                        type="button"
                        onClick={handleNext}
                    >
                        Next
                    </button>
                </div>
            </div>
        </RegisterLayout>
    );
};

export default StepAvailability;